/**
 * SoCare Konfigurator-Tracking v2.0 — VORLAGE (tracking-kit)
 *
 * Einheitliches DataLayer-Modul für ALLE Konfiguratoren (Tuning, Solar, Speicher, ...).
 * v2.0 (R13, 04.08.2026, Prince-Soll): Familie EXAKT symmetrisch zum Quiz
 * (quiz_start/quiz_progress/quiz_end/quiz_abandoned) und eine strenge Feuerabfolge:
 *
 *   configurator_start       ERSTE echte Bedienung (Eingabe/Auswahl/Klick im
 *                            Konfigurator) - NIE beim blossen Seitenaufruf
 *   configurator_progress    Erreichen eines NEUEN Schritts ab 2 (je Schritt einmal,
 *                            mit Schritt-Nr./Label/Prozent + Auswahl/Preis)
 *   configurator_end         Erreichen des LETZTEN Schritts (der mit dem
 *                            Lead-Formular) - mit vollem Ergebnis (Preis, items)
 *   scFormSubmit             Absenden des Lead-Formulars (tracking.js/Formular-Muster)
 *   configurator_handoff     optional: echte Shop-/Warenkorb-Uebergabe -> add_to_cart
 *   configurator_abandoned   Verlassen nach Start ohne Lead/Uebergabe (pagehide)
 *
 * ENTFALLEN gegenueber v1: configurator_step + configurator_result (Prince:
 * "nicht *step & *result") - deren Parameter tragen jetzt progress/end.
 *
 * Einbindungs-Vertrag (je Seite):
 *   1. scConfigurator.init({...}) wie gehabt.
 *   2. scConfigurator.interaktion() bei JEDER Bedienung rufen - am einfachsten EIN
 *      delegierter Capture-Listener auf dem Konfigurator-Wurzelelement:
 *        ['click','input','change'].forEach(function (t) {
 *          wurzel.addEventListener(t, function () { scConfigurator.interaktion(); }, true);
 *        });
 *      (Capture: laeuft garantiert VOR den Schritt-Handlern der Seite.)
 *   3. scConfigurator.step(n) bei jedem Schrittwechsel rufen (auch beim initialen
 *      Aufbau - das Modul filtert selbst: ohne Start und fuer Schritt 1 passiert
 *      nichts, rueckwaerts blaettern pusht nicht erneut).
 *   4. KEINE result()-Aufrufe mehr; handoff() nur bei echter Shop-Uebergabe.
 *
 * Grundsatz (DataLayer-Standard §1): hier werden nur FAKTEN gepusht. Die Uebersetzung
 * in GA4-/Meta-Namen (scConfiguratorStart/Progress/End) passiert im GTM.
 * KEINE personenbezogenen Daten in `selection`; bei Gesundheit/Art. 9 keine
 * eingriffs- oder diagnosespezifischen Auswahlwerte (Standard §4).
 * Abhaengigkeit: keine. Laeuft eigenstaendig.
 */

(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  var cfg = null;            // Konfiguration aus init()
  var gestartet = false;
  var uebergeben = false;    // Handoff ODER Lead erfolgt -> kein "abandoned" mehr
  var hoechsterSchritt = 1;  // Fortschritt zaehlt nur vorwaerts
  var endeGefeuert = false;

  function zahl(v) {
    var n = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.'));
    return isFinite(n) ? Math.round(n * 100) / 100 : undefined;
  }

  function beschriftung(i) {
    if (!cfg || typeof cfg.stepLabel !== 'function') return undefined;
    try { return cfg.stepLabel(i); } catch (e) { return undefined; }
  }

  /** Zustand vom Konfigurator abholen. Fehler duerfen das Tracking nie stoppen. */
  function zustand() {
    if (!cfg || typeof cfg.getState !== 'function') return {};
    try { return cfg.getState() || {}; } catch (e) { return {}; }
  }

  /** Felder, die auf JEDEM Ereignis mitlaufen. */
  function basis() {
    var b = {
      configurator_id: cfg.id,
      configurator_type: cfg.type,
      configurator_name: cfg.name,
      configurator_version: cfg.version,
      configurator_total: cfg.totalSteps
    };
    if (cfg.contentType) b.content_type = cfg.contentType;
    return b;
  }

  /** Auswahl + Preis + Treffer - ueberall dort, wo ein Ergebnis existiert. */
  function ergebnisFelder(s) {
    var f = {};
    if (s.selection) f.configurator_selection = s.selection;
    if (zahl(s.value) !== undefined) f.configurator_value = zahl(s.value);
    f.configurator_currency = s.currency || cfg.currency || 'EUR';
    if (s.match) f.configurator_match = s.match;           // set | einzelteile | kein_treffer | anfrage
    if (s.sku) f.configurator_sku = s.sku;
    if (s.variantId) f.configurator_variant_id = String(s.variantId);
    if (s.items && s.items.length) f.items = s.items;      // GA4-Struktur, unveraendert
    return f;
  }

  function schrittFelder(nr) {
    return {
      configurator_step: nr,
      configurator_label: beschriftung(nr - 1),
      configurator_percent: cfg.totalSteps ? Math.round((nr / cfg.totalSteps) * 100) : undefined
    };
  }

  function push(ereignis, extra) {
    if (!cfg) return;
    var nutzlast = basis();
    for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) nutzlast[k] = extra[k]; }
    nutzlast.event = ereignis;

    // GA4 liest Warenkorbdaten aus `ecommerce`. Liegt ein Produkt vor, laeuft der
    // Block zusaetzlich mit - vorher auf null, damit nichts Altes mitschleppt.
    if (nutzlast.items && nutzlast.items.length) {
      window.dataLayer.push({ ecommerce: null });
      nutzlast.ecommerce = {
        currency: nutzlast.configurator_currency,
        value: nutzlast.configurator_value,
        items: nutzlast.items
      };
    }
    window.dataLayer.push(nutzlast);
  }

  var api = {
    init: function (o) {
      cfg = o || {};
      if (cfg.autoAbandon !== false) {
        // pagehide statt beforeunload: beforeunload kommt auf iOS/Safari oft nicht.
        window.addEventListener('pagehide', function () { api.abandoned(); });
      }
      return api;
    },

    /**
     * ERSTE echte Bedienung - der EINZIGE Weg, configurator_start auszuloesen.
     * Von der Einbindung bei Eingabe/Auswahl/Klick gerufen (Capture-Listener).
     */
    interaktion: function () {
      if (gestartet || !cfg) return;
      gestartet = true;
      push('configurator_start', { configurator_step: 1, configurator_label: beschriftung(0) });
    },

    /**
     * Schrittwechsel melden (1-basiert). Pusht NUR:
     *  - wenn der Konfigurator gestartet wurde (echte Bedienung),
     *  - beim ERREICHEN eines neuen Hoechst-Schritts ab 2,
     *  - als configurator_progress; der LETZTE Schritt pusht configurator_end.
     * Seiten-Aufbau (Schritt 1) und Rueckwaerts-Blaettern sind stumm.
     */
    step: function (nr) {
      if (!cfg || !gestartet) return;
      if (!(nr >= 2) || nr <= hoechsterSchritt) return;
      hoechsterSchritt = nr;
      var felder = schrittFelder(nr);
      var e = ergebnisFelder(zustand());
      for (var k in e) { if (Object.prototype.hasOwnProperty.call(e, k)) felder[k] = e[k]; }
      if (nr === cfg.totalSteps) {
        if (endeGefeuert) return;
        endeGefeuert = true;
        push('configurator_end', felder);
      } else {
        push('configurator_progress', felder);
      }
    },

    /**
     * Echte Shop-/Warenkorb-Uebergabe -> GTM macht daraus add_to_cart/AddToCart.
     * NICHT fuer das Erreichen des Lead-Formulars (das ist configurator_end).
     * @param {string} ziel 'cart' | 'shop'
     */
    handoff: function (ziel) {
      if (!cfg) return;
      uebergeben = true;
      var felder = ergebnisFelder(zustand());
      felder.configurator_outcome = ziel || 'cart';
      felder.configurator_step = hoechsterSchritt;
      push('configurator_handoff', felder);
    },

    /** Lead abgeschickt (setzt tracking.js) - verhindert das Abbruch-Ereignis. */
    lead: function () { uebergeben = true; },

    abandoned: function () {
      if (!gestartet || uebergeben || !cfg) return;
      uebergeben = true;                          // nur einmal
      push('configurator_abandoned', {
        configurator_abandoned_at: hoechsterSchritt,
        configurator_abandoned_label: beschriftung(hoechsterSchritt - 1),
        configurator_percent: cfg.totalSteps
          ? Math.round((hoechsterSchritt / cfg.totalSteps) * 100) : undefined
      });
    }
  };

  window.scConfigurator = api;
})();
